<template>
  <div>
    <oil-form v-if='loading'
              :title='formTitle.toUpperCase()'
              :keys='keys'
              :items='act'
              :createForm='!id'
              :formCallback='formCallBack'
              :success-message='message'
    >
      <template v-slot:header='{id}'>
        <v-tooltip bottom>
          <template v-slot:activator='{ on, attrs }'>
            <v-btn v-if='id' class='mx-8' type='button' icon
                   @click="showMePdf('act/print',act.Id || id)"
                   v-bind='attrs'
                   v-on='on'
            >
              <v-icon>
                mdi-pdf-box
              </v-icon>
            </v-btn>
          </template>
          <span>СКАЧАТЬ И ПЕЧАТЬ</span>
        </v-tooltip>
      </template>
      <template v-slot:Buyer.Id='{rules,input}'>
        <v-autocomplete
          :items='buyers$'
          v-stream:keyup.native='searchCompany$'
          hide-no-data
          class='z-index'
          :disabled='!input.isEdit'
          clearable
          :rules='[...rules]'
          dense
          outlined
          @change='changeBuyer'
          hide-selected
          :value='act.Buyer.CompanyName'
          item-text='CompanyName'
          label='Выбрать покупателя'
          return-object
        ></v-autocomplete>
      </template>
      <template v-slot:Contract.Id='{rules,input}'>
        <v-autocomplete
          :items='contracts$'
          v-stream:keyup.native='searchContract$'
          hide-no-data
          :disabled='!input.isEdit'
          class='z-index'
          :rules='[...rules]'
          clearable
          @change='changeContract'
          dense
          outlined
          :value='act.Contract.Number'
          hide-selected
          item-text='Number'
          label='Выбрать договор'
          return-object
        ></v-autocomplete>
      </template>
    </oil-form>
  </div>
</template>

<script>
import { actService } from '@/services/actService'
import { form } from '@/pages/setting/act_create.json'
import { companiesService } from '@/services/CompaniesService'
import { contractsService } from '@/services/ContractsService'
import { debounceTime, distinctUntilChanged, filter, pluck, switchMap } from 'rxjs/operators'
import { coreApi } from '@/services/core'
import { waybillService } from '@/services/WayBillService'

export default {
  props: {
    id: String
  },
  components: {
    OilForm: () => import('@/components/helper/oil.form')
  },
  domStreams: ['searchCompany$', 'searchContract$'],
  subscriptions() {
    return {
      contracts$: this.searchContract$.pipe(
        pluck('event', 'target', 'value'),
        debounceTime(200),
        distinctUntilChanged(),
        switchMap(query => coreApi.get(`contract/search/number?pattern=${query}`)),
        pluck('data')
      ),
      buyers$: this.searchCompany$.pipe(
        pluck('event', 'target', 'value'),
        debounceTime(200),
        filter(value => value.length > 2),
        debounceTime(100),
        distinctUntilChanged(),
        switchMap(query => coreApi.get(`company/search/name?pattern=${query}`)),
        pluck('data')
      )
    }
  },
  data: () => ({
    loading: false,
    formTitle: 'Создать Акт сверки',
    keys: form.keys,
    act: {
      Number: '',
      StartDate: '',
      EndDate: '',
      Buyer: {
        Id: ''
      },
      Contract: {
        Id: '',
        Number: ''
      }
    },
    companies: [],
    contracts: []
  }),
  async created() {
    const companies = await companiesService.getAll()
    this.buyers$ = companies.data?.filter(({ IsActive }) => IsActive === true)
    this.keys['Buyer.Id'].attrs.items = this.companies
    if (this.id) {
      this.formTitle = 'инфо о Акт сверке'
      const act = await actService.actGetById(this.id)
      this.act = act.data
      const buyerId = this.act?.Buyer?.Id
      const contracts = await contractsService.contractCompanyById({ companyId: buyerId })
      this.contracts$ = contracts.data.filter(({ Status }) => Status === 'active')
    }

    const seller = await companiesService.seller()

    const {
      CompanyName,
      Address
    } = seller.data
    this.act.SellerInfo = `${CompanyName} ${Address}`

    this.loading = true
  },
  computed: {
    storeType() {
      return this.id ? actService.updateAct : actService.createAct
    },
    contractsRules() {
      return this.contracts?.filter(({ Status }) => Status === 'active')
    },
    message() {
      return this.id ? 'поздравлаем акт сверки удачно именен' : 'поздравлаем акт сверки удачно создан'
    }
  },
  methods: {
    openPdf(id, path) {
      window.open(process.env.VUE_APP_BACKEND_API + `/${path}/${id}`)
    },
    async formCallBack(data, input) {
      input.isEdit = false
      const response = await this.storeType(data)

      if (!response.data) {
        input.isEdit = true
        return
      }

      this.act.Id = response.data?.Id
      this.act = response.data
      const id = response.data?.Id
      if (!this.id) {
        await this.$router.replace({
          path: `/act/${id}`,
          replace: true
        })
      }
      this.openPdf(id, 'act/print')
    },
    async changeBuyer(buyer) {
      if (!buyer) return
      const id = buyer.Id
      this.act.Buyer = { ...buyer }
      const contracts = await contractsService.contractCompanyById({ companyId: id })
      this.contracts$ = contracts.data
    },
    async changeContract(contract) {
      if (!contract) return
      this.act.Contract = { ...contract }
    }
  },
  watch: {
    // async 'act.Buyer.Id'(id) {
    //   if (id && this.loading) {
    //     const buyer = this.companies.find(({Id}) => Id === id)
    //     this.act.Buyer = {...buyer}
    //     const contracts = await contractsService.contractCompanyById({companyId: buyer?.Id})
    //     this.contracts = contracts.data
    //   }
    // },
    // 'act.Contract.Id'(id) {
    //   if (id && this.loading) {
    //     this.act.Contract = {...this.contractsRules?.find(({Id}) => Id === id)}
    //   }
    // },
    // contractsRules(contracts) {
    //   this.keys["Contract.Id"].attrs.items = contracts
    // }
  }
}
</script>
